import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import BottomBar from "../../layouts/bottomBar/BottomBar";
import NavbarMobile from "../../layouts/navabrMobile/NavbarMobile";
import Navbar from "../../layouts/navbar/Navbar";
import MobileTermsConditions from "../../mobileView/termsCondtions/MobileTermsConditions";

const MobTermsConditions = () => {
  const [windowDimension, setWindowDimension] = useState(null);

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowDimension <= 640;

  return (
    <div>
      {isMobile ? <NavbarMobile /> : <Navbar />}
      <MobileTermsConditions />
      {isMobile ? <BottomBar /> : ""}
    </div>
  );
};

export default MobTermsConditions;
